<template>
  <div class="analysis-mobile">
    <div class="section">
      <div class="section-header">
        <h2 class="section-title">数据总览</h2>
        <el-button 
          type="text" 
          class="collapse-btn"
          @click="toggleSection('overview')"
        >
          <i :class="['el-icon-arrow-down', {'is-active': !collapsedSections.overview}]"></i>
        </el-button>
      </div>
      <div class="chart-row" v-show="!collapsedSections.overview">
        <study-effectiveness-mobile />
      </div>
    </div>

    <div class="section">
      <div class="section-header">
        <h2 class="section-title">赛事分析</h2>
        <el-button 
          type="text" 
          class="collapse-btn"
          @click="toggleSection('game')"
        >
          <i :class="['el-icon-arrow-down', {'is-active': !collapsedSections.game}]"></i>
        </el-button>
      </div>
      <div v-show="!collapsedSections.game">
        <div class="chart-row">
          <game-trend-chart-mobile />
        </div>
        <div class="chart-row">
          <game-count-trend-mobile />
        </div>
        <div class="chart-row">
          <game-distribution-chart-mobile />
        </div>
        <div class="chart-row">
          <game-scatter-chart-mobile />
        </div>
      </div>
    </div>

    <div class="section">
      <div class="section-header">
        <h2 class="section-title">题目分析</h2>
        <el-button 
          type="text" 
          class="collapse-btn"
          @click="toggleSection('question')"
        >
          <i :class="['el-icon-arrow-down', {'is-active': !collapsedSections.question}]"></i>
        </el-button>
      </div>
      <div v-show="!collapsedSections.question">
        <question-analysis-mobile :show-tag-charts="false" />
      </div>
    </div>

    <div class="section">
      <div class="section-header">
        <h2 class="section-title">标签分析</h2>
        <el-button 
          type="text" 
          class="collapse-btn"
          @click="toggleSection('tag')"
        >
          <i :class="['el-icon-arrow-down', {'is-active': !collapsedSections.tag}]"></i>
        </el-button>
      </div>
      <div v-show="!collapsedSections.tag">
        <tag-heatmap-mobile />
        <question-analysis-mobile :only-tag-charts="true" />
      </div>
    </div>
    
    <!-- 版权信息 -->
    <div class="copyright-info">
      Copyright © 2024 OIer之路 All rights reserved.<br>闽ICP备2025095302号-1
    </div>
  </div>
</template>

<script>
import StudyEffectivenessMobile from './components/mobile/StudyEffectivenessMobile.vue'
import GameTrendChartMobile from './components/mobile/GameTrendChartMobile.vue'
import GameCountTrendMobile from './components/mobile/GameCountTrendMobile.vue'
import GameDistributionChartMobile from './components/mobile/GameDistributionChartMobile.vue'
import GameScatterChartMobile from './components/mobile/GameScatterChartMobile.vue'
import QuestionAnalysisMobile from './components/mobile/QuestionAnalysisMobile.vue'
import TagHeatmapMobile from './components/TagHeatmapMobile.vue'

export default {
  name: 'AnalysisMobile',
  components: {
    StudyEffectivenessMobile,
    GameTrendChartMobile,
    GameCountTrendMobile,
    GameDistributionChartMobile,
    GameScatterChartMobile,
    QuestionAnalysisMobile,
    TagHeatmapMobile
  },
  data() {
    return {
      collapsedSections: {
        overview: false,
        game: false,
        question: false,
        tag: false
      }
    }
  },
  methods: {
    toggleSection(section) {
      this.collapsedSections[section] = !this.collapsedSections[section]
    }
  }
}
</script>

<style scoped>
.analysis-mobile {
  padding: 8px 0;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.section {
  margin-bottom: 20px;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  margin-bottom: 0;
}

.section-title {
  font-size: 16px;
  font-weight: 500;
  color: #2E365A;
  position: relative;
  padding-left: 12px;
  display: flex;
  align-items: center;
  margin: 0;
}

.section-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 16px;
  background: #409EFF;
  border-radius: 2px;
}

.collapse-btn {
  padding: 0;
  height: auto;
}

.collapse-btn i {
  font-size: 20px;
  color: #909399;
  transition: transform 0.3s;
}

.collapse-btn i.is-active {
  transform: rotate(180deg);
}

.chart-row {
  width: 100%;
  margin-bottom: 0;
}

.chart-row:last-child {
  margin-bottom: 0;
}

.full-width {
  width: 100%;
}

.coming-soon {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  background: #f8f9fa;
  border-radius: 8px;
  margin: 16px;
  color: #666;
}

.coming-soon i {
  font-size: 32px;
  color: #409EFF;
  margin-bottom: 12px;
  animation: rotate 2s linear infinite;
}

.coming-soon p {
  font-size: 16px;
  margin: 0;
}

@keyframes rotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.copyright-info {
  text-align: center;
  color: #909399;
  font-size: 12px;
  margin-top: 16px;
  margin-bottom: 8px;
  line-height: 1.5;
  padding-bottom: 16px;
}

/* 响应式设计 */
@media (max-width: 480px) {
  .analysis-mobile {
    padding: 0;
  }
  
  .section {
    margin-bottom: 14px;
    border-radius: 0;
  }
  
  .section-header {
    padding: 12px 16px;
  }
  
  .section-title {
    font-size: 16px;
  }
  
  .section-title::before {
    width: 3px;
    height: 14px;
  }
  
  .collapse-btn i {
    font-size: 18px;
  }
}
</style> 